import { render } from "./LearningPaths.vue?vue&type=template&id=33d7501e&scoped=true"
import script from "./LearningPaths.vue?vue&type=script&lang=js"
export * from "./LearningPaths.vue?vue&type=script&lang=js"

import "./LearningPaths.vue?vue&type=style&index=0&id=33d7501e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d7501e"]])

export default __exports__